import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import UpdateCompany from "./UpdateCompany";
import MoreInfo from "./MoreInfo.jsx";
import BlockCompany from "./BlockCompany";
import GenerateEmail from "./GenerateEmail";
import RegenerateEmail from "./RegenerateEmail";
import Block from "./Block";
import ReactivateOfCompany from "./ReactivateOfCompany";

export default function AccountMenu({ id, status, setIsWaiting, getCompanies }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <React.Fragment>
            <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
                <Tooltip title="Account settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                    >
                        <Avatar sx={{ width: 32, height: 32 }}>A</Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                // onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                {/* <MenuItem>
          <MoreInfo id={id} />
        </MenuItem> */}
                <MenuItem>
                    <UpdateCompany id={id} getCompanies={getCompanies} handleMenuClose={handleClose} />
                </MenuItem>
                <MenuItem disabled={status !== 1}>
                    <GenerateEmail id={id} setIsWaiting={setIsWaiting} getCompanies={getCompanies} handleMenuClose={handleClose} />
                </MenuItem>
                <MenuItem disabled={status !== 3}>
                    <RegenerateEmail id={id} setIsWaiting={setIsWaiting} getCompanies={getCompanies} handleMenuClose={handleClose} />
                </MenuItem>
                <MenuItem disabled={status !== 5}>
                    <Block id={id} setIsWaiting={setIsWaiting} getCompanies={getCompanies} handleMenuClose={handleClose} />
                </MenuItem>
                <MenuItem disabled={status !== 6}>
                    <ReactivateOfCompany id={id} setIsWaiting={setIsWaiting} getCompanies={getCompanies} handleMenuClose={handleClose} />
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
